import Logger from './logger';

const log = new Logger();

/**
 * setGeoLoc:
 * Takes a given data object and geo location cookie data and
 * injects the location data into the data object
 *
 * @param data
 * @returns {*}
 */
export default (data) => {
  const { getcookie } = window;

  if (!getcookie) {
    return data;
  }

  let geolocation = getcookie('geolocation') || '';

  if (geolocation === undefined || geolocation === '') {
    log.debug({
      category: 'helpers',
      message: 'setGeoLocationData',
      data: {
        geolocation: false
      }
    });

    return data;
  }

  geolocation = JSON.parse(geolocation);
  data.Geo_Continent__c = geolocation.continent;
  data.Geo_Country__c = geolocation.country;
  data.Geo_State__c = geolocation.state;
  data.Geo_City__c = geolocation.city;
  data.Geo_Postal_Code__c = geolocation.zip;
  data.Geo_Time_Zone__c = geolocation.timezone;
  data.Geo_Latitude__c = geolocation.latitude;
  data.Geo_Longitude__c = geolocation.longitude;
  data.Geo_Ip__c = geolocation.ip;

  log.debug({
    category: 'helpers',
    message: 'setGeoLocationData',
    data: { geolocation }
  });

  return data;
};
